module.exports = __webpack_public_path__ + "static/media/img_onboarding_header_bg_mobile.9734ea51.png";